import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const SoundMutedIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('SoundMutedIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12.05 7.15 2.7 2.7m-2.7 0 2.7-2.7M4.625 6.137H2.6a1.35 1.35 0 0 0-1.35 1.35v2.025c0 .746.604 1.35 1.35 1.35h2.025L9.35 13.9V3.1z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
SoundMutedIcon.id = 'SoundMutedIcon';
SoundMutedIcon.displayName = 'SoundMutedIcon';
export default SoundMutedIcon;
